module.exports = __webpack_public_path__ + "bed-temp-bar.269acf84.png";